/**
 * Implements the debug tabbed panel.
 * Injects views into SQL and Stack Trace tabs.
 *
 * This component is instantiated by the main App.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import GenericView from "../generic/view";
import SQLView from "./sql-list";
import StackTraceView from "./stacktrace-list";
import SQLCollection from "../../collections/debug-sql";
import StackTraceCollection from "../../collections/debug-stacktrace";

const channel = Radio.channel("report");

class View extends Marionette.LayoutView {
  el() {
    return "#debug-panel";
  }

  regions() {
    return {
      sql: "div.tab-content #sql",
      stackTrace: "div.tab-content #stacktrace",
    };
  }

  initialize() {
    this.noDataView = new GenericView({
      template: _.template("<p>No data is available at this time.</p>"),
    });

    // add listeners
    this.listenTo(channel, "debug:data", this._handleDebugData);
  }

  _handleDebugData(data) {
    // inject view into SQL tab
    if (data.sql) {
      this.sql.show(
        new SQLView({
          collection: new SQLCollection(data.sql || []),
        })
      );
    } else {
      this.sql.show(this.noDataView);
    }

    // inject view into Stack Trace tab
    if (data.stacktrace) {
      this.stackTrace.show(
        new StackTraceView({
          collection: new StackTraceCollection(data.stacktrace || []),
        })
      );
    } else {
      this.stackTrace.show(this.noDataView);
    }
  }
}

export { View as default };
